import { render, staticRenderFns } from "./MineSegmentDetail.vue?vue&type=template&id=13c52706&scoped=true"
import script from "./MineSegmentDetail.vue?vue&type=script&lang=js"
export * from "./MineSegmentDetail.vue?vue&type=script&lang=js"
import style0 from "./MineSegmentDetail.vue?vue&type=style&index=0&id=13c52706&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c52706",
  null
  
)

export default component.exports